module.exports = __webpack_public_path__ + "img/warn_10.62648786.png";